import "src/decidim/notify/notify.js";
import "src/decidim/notify/notify_selects";
import "src/decidim/notify/notify_channel";
require.context("../images", true);
import "entrypoints/decidim_notify_component.scss";
